import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import Utils from '@iv/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorService {

  constructor() { }

  public handleError(error: HttpErrorResponse): Error {
    let errorMessage: string;
    if (error.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${error.error.message}`;
    } else {
      switch (error.status) {
        case 400:
          return Utils.getError('BadRequest', 'Bad request.');
        case 401:
          return Utils.getError('UserNotAuthorizedError', 'User not authorized.');
        case 403:
          return Utils.getError('AccessDeniedError', 'Access denied.');
      }
    }
    console.error(errorMessage ? errorMessage : "");
  }
}
